import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Back",
	updateManyExternalIntegrations: {
		success: "Integrations updated successfully",
	},
	externalStoreIntegrationStatus: {
		synced: "Synced",
		pendingSyncing: "Syncing pending",
		pendingImporting: "Importing pending",
	},
	ordersManager: {
		title: "Orders Manager",
		description:
			"Track and manage orders that come from Entregue já, Comanda Online and Pedido na mesa.",
		filter: {
			placeholder: "Filter by",
		},
		tabs: {
			newOrders: "New Orders",
			completed: "Completed",
		},
		loading: "Loading",
		total: "Total: {{value}}",
		new: "New",
		emptyState: {
			title: "We don't have any pending orders yet.",
			description: "We'll show you here when you receive new orders.",
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
